import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useEffect, useState } from "react";
import { Col, OverlayTrigger, Row, Tab, Tabs, Tooltip } from "react-bootstrap";

const TopEngagement = ({ type, regions, filters, contents }) => {
  const path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const colors = ["#59C3B5", "#F2C245", "#E57F86", "#8B4EA8", "#C29AD9"];
  const [pieOption, setPieOption] = useState({
    chart: {
      type: "pie",
      height: 200,
      width: 200,
    },
    title: {
      text: "",
    },
    legend: {
      enabled: false,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemMarginTop: 5,
      itemMarginBottom: 5,
    },
    tooltip: {
      useHTML: true,
      outside: true,
      backgroundColor: "transparent",
      borderWidth: 0,
      shadow: false,
      formatter: function () {
        return `${this.point.name} : <b>${this.point.percentage.toFixed(1)}% (${this.y})</b>`;
      },
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
  });

  useEffect(() => {
    if (regions && regions?.length) {
      const series = [
        {
          name: "Engagement",
          data: regions?.map((item) => ({
            name: item?.region,
            y: item?.count,
            percentage: item?.percentage,
          })),
        },
      ];

      setPieOption((prev) => ({
        ...prev,
        series,
      }));
    }
  }, [regions]);

  function LinkWithTooltip({ children, tooltip }) {
    return (
      <OverlayTrigger
        overlay={<Tooltip>{tooltip}</Tooltip>}
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <a href="#">{children}</a>
      </OverlayTrigger>
    );
  }

  const CustomTable = ({
    data = [],
    className = "",
    firstColumnLabel = "",
    metricLabel = "Freq",
    showAvg = false,
  }) => {
    return (
      <table className={`custom-table ${className}`}>
        <thead>
          <tr>
            <th>{firstColumnLabel}</th>
            <th>{metricLabel}</th>
            {showAvg && <th>Avg</th>}
          </tr>
        </thead>
        <tbody>
          {data && data.length ? (
            data.map((d, i) => {
              return (
                <tr key={i}>
                  <td className="col-label-wrapper">
                    <span className="table-index">{i + 1}.</span>
                    <span className="table-label">{d.value}</span>
                  </td>
                  <td className="col-value">{d.count}</td>
                  {showAvg && <td className="col-avg">{d.avg || 0}</td>}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="3">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  const GetTopEngagement = ({
    data,
    name,
    className,
    tooltip,
    metricLabel,
    showAvg = false,
  }) => {
    return (
      <Col
        className="hcp-profile-view vwd-engagement"
        id="box-2"
        data-printable="true"
      >
        <div className="hcp-profile-content live-events-graph">
          <div className={"table-header" + " " + className}>
            <h6 className="tab-content-title">
              Top 5 {name}
              <LinkWithTooltip tooltip={tooltip}>
                <img
                  src={path_image + "info_circle_icon.svg"}
                  alt="refresh-btn"
                  style={{ marginLeft: "8px" }}
                />
              </LinkWithTooltip>
            </h6>
            <p className="p-0">Engagement in last 12 months</p>
          </div>

          <div className="profile-view-graph">
            {" "}
            {data?.length ? (
              <CustomTable
                data={data}
                className={className}
                firstColumnLabel={name}
                metricLabel={metricLabel}
                showAvg={showAvg}
              />
            ) : (
              <div className="no-data">No data available</div>
            )}
          </div>
        </div>
      </Col>
    );
  };

  return (
    <div className="profile-engagement">
      <div className="profile-engagement-block">
        <Row>
          {type === "dashboard" && (
            <Col
              className="hcp-profile-view vwd-top-region"
              id="box-1"
              data-printable="true"
            >
              <div className="profile-title d-flex align-items-center justify-content-between">
                <p>Top 5 Regions</p>
              </div>
              <div className="hcp-profile-content live-events-graph">
                <p>Visits in all-time</p>
                {regions?.length > 0 ? (
                  <div className="profile-view-graph region-chart-layout">
                    <div className="region-info-box">
                      {regions
                        ?.sort((a, b) => b.count - a.count)
                        ?.slice(0, 5)
                        ?.map((item, index) => (
                          <div className="region-info-row" key={index}>
                            <span
                              className="region-dot"
                              style={{ backgroundColor: colors[index] }}
                            ></span>
                            <span className="region-text">
                              {index + 1}. {item.region} |{" "}
                              <strong>{`${item.percentage}% (${item.count})`}</strong>
                            </span>
                          </div>
                        ))}
                    </div>
                    <div className="region-pie-chart">
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={pieOption}
                      />
                    </div>
                  </div>
                ) : (
                  <div class="no-data">No data available</div>
                )}
              </div>
            </Col>
          )}

          <Col className="vwd-engagement-table">
            <div className="live-stream-tabs-data">
              <Tabs defaultActiveKey="filter-details" fill>
                <Tab
                  eventKey="filter-details"
                  title="Filter engagement"
                  className="flex-column justify-content-between"
                >
                  <Row>
                    <GetTopEngagement
                      name="Ages"
                      className="age-table"
                      data={filters?.associated_age_clicked}
                      metricLabel="Clicks"
                      tooltip={
                        'Engagements with the Ages through the filter (selecting an age at the top of the "Touchpoints" page in VWD Journey Platform)'
                      }
                      showAvg={type === "profile"}
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Touchpoints"
                      className="touchpoints-table"
                      data={filters?.associated_touchpoint_clicked}
                      metricLabel="Clicks"
                      tooltip={
                        'Engagements with the Touchpoints through the filter (selecting a touchpoint at the top of the \"Touchpoints\" page in VWD Journey Platform)'
                      }
                      showAvg={type === "profile"}
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Topics"
                      className="topic-table"
                      data={filters?.topSelectedTags}
                      metricLabel="Clicks"
                      tooltip={
                        'Engagements with the Topics through the search bar (using the topics in the search bar at the \"Touchpoints Or Resources\" pages in VWD Journey Platform'
                      }
                      showAvg={type === "profile"}
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Content Types"
                      className="content-table"
                      data={filters?.category_clicked}
                      metricLabel="Clicks"
                      tooltip={
                        'Engagements with the Content type through the filter (selecting a content type at the middle of the \"Touchpoints\" page in VWD Journey Platform)'
                      }
                      showAvg={type === "profile"}
                    ></GetTopEngagement>
                  </Row>
                </Tab>

                <Tab
                  eventKey="content-details"
                  title="Content engagement"
                  className="flex-column justify-content-between"
                >
                  <Row>
                    <GetTopEngagement
                      name="Ages"
                      className="age-table"
                      data={contents?.categoryCount}
                      metricLabel="Views"
                      tooltip={
                        "Engagements with the Ages through content (by opening the content including this age)"
                      }
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Touchpoints"
                      className="touchpoints-table"
                      data={contents?.touchpointCount}
                      metricLabel="Views"
                      tooltip={
                        "Engagements with the Touchpoint through content (by opening the content including this touchpoint)"
                      }
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Topics"
                      className="topic-table"
                      data={contents?.topicCount}
                      metricLabel="Views"
                      tooltip={
                        "Engagements with the Topic through content (by opening the content including this topic"
                      }
                    ></GetTopEngagement>
                    <GetTopEngagement
                      name="Content Types"
                      className="content-table"
                      data={contents?.contentTypeCount}
                      metricLabel="Views"
                      tooltip={
                        "Engagements with the Content type through content (by opening the content of this type)"
                      }
                    ></GetTopEngagement>
                  </Row>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TopEngagement;